import styled from 'styled-components';

export const Container = styled.div`
  width: fit-content;
  max-width: 100%;
  margin: 10vh auto 0;
  display: flex;
  align-items: center;
`;
